/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Nav_InstallInputs */

const en_pc_nav_install = /** @type {(inputs: Pc_Nav_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install`)
};

const zh_pc_nav_install = /** @type {(inputs: Pc_Nav_InstallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装`)
};

/**
* | output |
* | --- |
* | "Install" |
*
* @param {Pc_Nav_InstallInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_nav_install = /** @type {((inputs?: Pc_Nav_InstallInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Nav_InstallInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_nav_install(inputs)
	return zh_pc_nav_install(inputs)
});
export { pc_nav_install as "pc.nav.install" }